export const helpSections = [
  {
    id: "primeiros-passos",
    title: "Primeiros Passos",
    summary: "Entenda a estrutura do produto e a ordem recomendada para começar.",
    steps: [
      "Acesse o Agente de Contabilidade pelo menu de produtos do Portal do Cliente.",
      "Comece por Importação de Dados e envie o relatório MAPA extraído do Sienge.",
      "Depois da importação, escolha uma empresa ou Todos Empreendimentos no seletor das páginas.",
      "Use o seletor de mês/ano para consultar o período desejado e navegue pelos módulos.",
    ],
    details: [
      {
        title: "Empresa, empreendimento e período",
        text: "A empresa identifica a operação disponível no portal. Os dados importados são organizados por empreendimento e por mês/ano. A troca do período altera os indicadores exibidos sem modificar os dados importados.",
      },
      {
        title: "Todos Empreendimentos",
        text: "Essa opção apresenta a visão consolidada do mês selecionado. Valores financeiros são somados e indicadores percentuais utilizam média simples entre os empreendimentos que possuem dados naquele período.",
      },
    ],
    notice: {
      severity: "important",
      text: "A ordem recomendada é: importar os dados, validar a empresa e o período, analisar os módulos e, por último, criar simulações na DRE de Viabilidade.",
    },
  },
  {
    id: "importacao-de-dados",
    title: "Importação de Dados",
    summary: "Envie o MAPA do Sienge e acompanhe cada etapa de validação.",
    steps: [
      "No Sienge, gere o relatório MAPA com os dados atualizados do empreendimento.",
      "Acesse Importação de Dados e clique em Importar arquivo.",
      "Selecione o arquivo XLSX no computador. O portal valida o arquivo e a estrutura do relatório.",
      "Acompanhe as etapas de recebimento, leitura, validação do template, tratamento e carga no portal.",
      "Após a conclusão, confira o resultado e o registro apresentado no histórico.",
    ],
    details: [
      {
        title: "Sucesso, duplicidade e erro",
        text: "Uma importação concluída informa os registros processados. Se o arquivo não tiver alterações, o portal identifica a duplicidade. Quando houver erro, a etapa responsável é destacada com uma mensagem para correção.",
      },
      {
        title: "Histórico de importações",
        text: "O histórico registra os arquivos enviados e os resultados do processamento. A remoção de um item do histórico é lógica e não desfaz os dados que já foram consolidados nos dashboards.",
      },
    ],
    notice: {
      severity: "attention",
      text: "Não altere nomes de colunas ou a estrutura do relatório MAPA antes da importação.",
    },
    actions: [
      { label: "Ir para Importação de Dados", to: "/agentecontabilidade/importacao" },
    ],
  },
  {
    id: "api-sienge",
    title: "Importar via Sienge",
    summary: "Importe os dados do MAPA Imobiliário diretamente pelo Sienge, sem enviar arquivo manualmente.",
    steps: [
      "Acesse Importação de Dados e clique em Importar via Sienge.",
      "Confira o período sugerido ou ajuste as datas conforme a necessidade da carga.",
      "Clique em Atualizar empreendimentos para buscar a lista mais recente do Sienge.",
      "Use a pesquisa e o filtro Somente com CNPJ para encontrar os empreendimentos desejados.",
      "Selecione os empreendimentos que serão importados e confirme a importação.",
      "Ao finalizar, valide o histórico de importações e consulte os dados nas abas do produto.",
    ],
    details: [
      {
        title: "O que é",
        text: "É uma forma de buscar os dados do MAPA Imobiliário diretamente no Sienge. Quando disponível, ela reduz o trabalho manual de exportar e enviar arquivos XLSX.",
      },
      {
        title: "Como a importação funciona",
        text: "O portal mostra os empreendimentos encontrados, você escolhe quais deseja importar e o sistema carrega os dados nas mesmas telas usadas pela importação por arquivo.",
      },
      {
        title: "Centros existentes e pendentes",
        text: "Existe no portal indica que o empreendimento já está vinculado. Pendente no portal indica que ele foi encontrado no Sienge, mas ainda precisa ser revisado antes de entrar no fluxo normal.",
      },
      {
        title: "Quando acionar suporte",
        text: "Acione o suporte se a lista não carregar, se nenhum empreendimento aparecer mesmo após atualizar, ou se a importação não concluir depois de uma nova tentativa.",
      },
      {
        title: "Alternativa manual",
        text: "Se a importação via Sienge não estiver disponível no momento, utilize Importar arquivo para enviar o XLSX do MAPA.",
      },
    ],
    notice: {
      severity: "attention",
      text: "Se o problema continuar, não tente ajustar configurações por conta própria. Acione o suporte para verificar a integração.",
    },
    actions: [
      { label: "Abrir Importação de Dados", to: "/agentecontabilidade/importacao" },
    ],
  },
  {
    id: "visao-geral",
    title: "Visão Geral",
    summary: "Consulte os principais indicadores financeiros e a evolução mensal.",
    steps: [
      "Escolha uma empresa ou Todos Empreendimentos.",
      "Selecione o mês/ano desejado.",
      "Analise os cards de indicadores e compare sua evolução nos gráficos.",
      "Use as opções do gráfico para alternar o indicador e a forma de visualização.",
    ],
    details: [
      {
        title: "Participação Mensal",
        text: "Na visão Todos Empreendimentos, a mensagem de Participação Mensal informa quais empreendimentos possuem dados no período escolhido e participam da consolidação.",
      },
      {
        title: "KPIs",
        text: "A Visão Geral apresenta VGV Contratado, Receita Apropriada, Custo Apropriado, Recebimentos Acumulados, Percentual Vendido, Tendência da Margem Líquida e, na visão individual, % POC - Percentage of Completion. Margem Líquida na Viabilidade aparece quando houver simulação selecionada.",
      },
      {
        title: "Consolidação",
        text: "Valores monetários são somados. Percentuais usam média simples somente entre os empreendimentos participantes do mês selecionado.",
      },
    ],
    notice: {
      severity: "tip",
      text: "Passe o cursor sobre os elementos dos gráficos para consultar os valores de cada período.",
    },
  },
  {
    id: "dre-de-viabilidade",
    title: "DRE de Viabilidade",
    summary: "Crie metas e simulações mensais para analisar a viabilidade do empreendimento.",
    steps: [
      "Selecione a empresa e o mês-base da análise.",
      "Clique em Nova versão para iniciar uma simulação.",
      "Preencha os campos editáveis da planilha. Os valores monetários são formatados automaticamente.",
      "Informe o nome e, quando necessário, uma descrição para a simulação.",
      "Clique em Salvar. A versão passa a aparecer no Histórico de simulações.",
      "Selecione uma versão salva para consultar, alterar ou excluir seus dados.",
    ],
    details: [
      {
        title: "Colunas da planilha",
        text: "Viabilidade R$ representa a meta informada na simulação. Apropriado indica o realizado; A Apropriar e A Contratar representam valores futuros; A Realizar é a soma dessas duas colunas; Tendência combina o apropriado com o valor a realizar.",
      },
      {
        title: "Cálculos",
        text: "A Realizar = A Apropriar + A Contratar. Tendência = Apropriado + A Realizar. Subtotais e percentuais são recalculados conforme os campos são alterados.",
      },
      {
        title: "Histórico",
        text: "O histórico aparece quando existem versões salvas para a empresa. A versão selecionada fica destacada e pode ser atualizada somente depois de alguma alteração válida.",
      },
    ],
    notice: {
      severity: "important",
      text: "Uma simulação pertence ao mês-base em que foi criada. Ao consultar outro período, selecione ou crie uma versão correspondente.",
    },
    actions: [
      { label: "Abrir DRE de Viabilidade", to: "/agentecontabilidade/dre-viabilidade" },
    ],
  },
  {
    id: "receita-de-vendas",
    title: "Receita de Vendas",
    summary: "Acompanhe receitas, VGV, vendas e o avanço físico do empreendimento.",
    steps: [
      "Selecione a empresa e o mês/ano.",
      "Compare os indicadores do período nos cards.",
      "Acompanhe a evolução mensal no gráfico.",
    ],
    details: [
      {
        title: "% POC - Percentage of Completion",
        text: "O POC representa o percentual de avanço utilizado no reconhecimento do resultado do empreendimento.",
      },
      {
        title: "Leitura dos indicadores",
        text: "Observe o VGV, o percentual vendido e a evolução das receitas em conjunto. Um único indicador isolado não descreve todo o desempenho comercial.",
      },
    ],
  },
  {
    id: "carteira-de-recebiveis",
    title: "Carteira de Recebíveis",
    summary: "Analise recebimentos, valores a receber e comportamento mensal da carteira.",
    steps: [
      "Selecione a empresa e o período.",
      "Consulte os cards de recebimentos e contas a receber.",
      "Use o gráfico para comparar a evolução da carteira entre os meses.",
    ],
    details: [
      {
        title: "Contas recebidas e a receber",
        text: "Os indicadores separam valores já recebidos daqueles que permanecem previstos na carteira contábil.",
      },
      {
        title: "Inadimplência",
        text: "Quando disponível no dado importado, a inadimplência ajuda a identificar valores vencidos ou com risco de recebimento.",
      },
    ],
  },
  {
    id: "custo-do-empreendimento",
    title: "Custo do Empreendimento",
    summary: "Acompanhe custos realizados, compromissos futuros e tendência final.",
    steps: [
      "Escolha a empresa e o mês/ano.",
      "Compare o custo apropriado com os valores a apropriar e a contratar.",
      "Observe a tendência para estimar o custo total projetado.",
      "Use os gráficos para identificar mudanças entre períodos.",
    ],
    details: [
      {
        title: "A Realizar e Tendência",
        text: "A Realizar combina A Apropriar e A Contratar. A Tendência considera o valor já apropriado somado ao que ainda será realizado.",
      },
    ],
  },
  {
    id: "gestao-de-impostos",
    title: "Gestão de Impostos",
    summary: "Configure alíquotas e acompanhe a projeção tributária.",
    steps: [
      "Selecione uma empresa específica.",
      "Escolha o regime tributário aplicável.",
      "Revise ou preencha as alíquotas disponíveis.",
      "Confira a Alíquota Efetiva e os cards recalculados.",
      "Clique em Salvar alíquotas para persistir a configuração ou use Restaurar padrão.",
    ],
    details: [
      {
        title: "Regimes tributários",
        text: "Lucro Presumido, RET e Lucro Real possuem configurações predefinidas. O modo Personalizado permite informar as alíquotas conforme a necessidade da empresa.",
      },
      {
        title: "Alíquota Efetiva",
        text: "É o percentual resultante das alíquotas configuradas e utilizado para recalcular os indicadores tributários da tela.",
      },
    ],
    notice: {
      severity: "attention",
      text: "Alterações exibidas nos cards só ficam persistidas depois de clicar em Salvar alíquotas.",
    },
  },
  {
    id: "gestao-de-despesas",
    title: "Gestão de Despesas",
    summary: "Consulte despesas operacionais, financeiras e valores vindos da simulação.",
    steps: [
      "Selecione a empresa e o período.",
      "Consulte os valores calculados automaticamente a partir dos dados disponíveis.",
      "Selecione uma simulação salva no histórico para carregar os indicadores planejados de despesas.",
      "Para trocar a simulação em uso, clique em outra versão no Histórico de simulações.",
      "Analise o Total das Despesas Operacionais e o Resultado Financeiro.",
    ],
    details: [
      {
        title: "Valores automáticos",
        text: "Na ausência de valores válidos na DRE, a página mantém os cálculos automáticos já existentes para a empresa e o período.",
      },
      {
        title: "Relação com a DRE",
        text: "Valores positivos de Corretagem, Publicidade, Administração Central, Despesa Tributária, Receita Financeira e Despesa Financeira podem ser refletidos a partir da simulação selecionada no histórico.",
      },
      {
        title: "Sem simulação",
        text: "Quando o empreendimento ainda não possui simulações, use o botão para abrir a DRE de Viabilidade e criar a primeira versão.",
      },
      {
        title: "Totais",
        text: "O Total das Despesas Operacionais soma Corretagem, Publicidade, Administração Central e Despesa Tributária. O Resultado Financeiro corresponde à Receita Financeira menos a Despesa Financeira.",
      },
    ],
  },
  {
    id: "agente",
    title: "Agente",
    summary: "Use o assistente para consultar os dados do módulo em linguagem natural.",
    steps: [
      "Clique no botão Agente, exibido no canto da tela dos módulos compatíveis.",
      "Escreva uma pergunta objetiva e informe o período quando ele for importante.",
      "Confira se a empresa e o mês selecionados na página correspondem ao contexto da pergunta.",
      "Use a resposta como apoio para a análise dos indicadores.",
    ],
    details: [
      {
        title: "Exemplos de perguntas",
        text: "Pergunte: “Qual foi o maior custo do período?”, “Como evoluiu a receita apropriada?” ou “Quais indicadores merecem atenção neste mês?”.",
      },
      {
        title: "Contexto da página",
        text: "A aba atual, a empresa e o período selecionados ajudam o Agente a compreender quais dados devem ser considerados.",
      },
      {
        title: "Limitações",
        text: "Respostas do assistente apoiam a interpretação, mas não substituem validações contábeis, fiscais ou decisões profissionais.",
      },
    ],
    notice: {
      severity: "tip",
      text: "Perguntas com indicador, empresa e período explícitos tendem a produzir respostas mais precisas.",
    },
  },
  {
    id: "problemas-comuns",
    title: "Dúvidas e Problemas Comuns",
    summary: "Consulte orientações rápidas para situações frequentes.",
    details: [
      {
        title: "Nenhum dado disponível",
        text: "Verifique se existe uma importação para a empresa e se o mês selecionado possui dados. Ao trocar de empresa, o portal pode selecionar automaticamente o período disponível mais próximo.",
      },
      {
        title: "Arquivo rejeitado",
        text: "Confirme se o arquivo é XLSX, se corresponde ao MAPA do Sienge e se a estrutura original das colunas foi preservada.",
      },
      {
        title: "Mês sem informações",
        text: "O empreendimento pode não possuir registros no período escolhido. Navegue para outro mês ou consulte a Participação Mensal na visão consolidada.",
      },
      {
        title: "Simulação não localizada",
        text: "Confirme se a empresa e o mês-base são os mesmos da versão salva. As simulações são exibidas no histórico correspondente.",
      },
      {
        title: "Sessão expirada",
        text: "Quando o token de acesso expira, o portal solicita uma nova autenticação para proteger os dados do cliente.",
      },
      {
        title: "Dados demorando para atualizar",
        text: "Durante uma nova consulta, aguarde o indicador Atualizando dados. Evite repetir o clique enquanto a requisição estiver em andamento.",
      },
    ],
  },
  {
    id: "glossario",
    title: "Glossário",
    summary: "Consulte o significado dos principais termos utilizados no produto.",
    glossary: [
      ["VGV", "Valor Geral de Vendas do empreendimento."],
      ["POC", "Percentage of Completion, percentual de avanço usado no reconhecimento do resultado."],
      ["Receita Apropriada", "Parcela da receita reconhecida contabilmente no período."],
      ["Custo Apropriado", "Parcela do custo reconhecida contabilmente no período."],
      ["A Apropriar", "Valor existente que ainda será apropriado contabilmente."],
      ["A Contratar", "Valor previsto que ainda não foi contratado."],
      ["A Realizar", "Soma dos valores a apropriar e a contratar."],
      ["Tendência", "Projeção formada pelo valor apropriado somado ao valor a realizar."],
      ["Margem Líquida", "Resultado líquido em relação à base de receita ou VGV considerada."],
      ["Contas a Receber", "Valores da carteira que ainda serão recebidos."],
      ["Participação Mensal", "Empreendimentos que possuem dados e participam da consolidação do mês."],
    ],
  },
];
